/* 
  Takes base url and formats it for React Router
  Example: /profile/personal-information as nested url, baseUrl as base results in personal-information as output
*/
export function formatNestedPath(nestedUrl: string, baseUrl: string): string {
  return nestedUrl.replace(baseUrl, "").substring(1)
}
